import { Link } from "react-router-dom";
import { Seo } from "@/components/site/Seo";
import { BUSINESS } from "@/content/site";

const DOCS = {
  privacy: {
    title: "Privacy Policy",
    body: [
      "Solar Energy Doc LLC respects your privacy. When you submit a quote request or contact form, we collect the information you provide — such as your name, phone number, email address, city, property type and message.",
      "We use this information only to respond to your request, provide quotes and deliver services. We do not sell your personal information.",
      "We may use basic website analytics to understand how visitors use this site and improve it.",
      `To ask about or remove your information, contact us at ${BUSINESS.email} or ${BUSINESS.phoneDisplay}.`,
      "[Business owner: review this policy with a legal professional before publishing.]",
    ],
  },
  terms: {
    title: "Terms of Service",
    body: [
      "The content on this website is provided for general information about the services offered by Solar Energy Doc LLC.",
      "Quotes, recommendations and service scopes are provided after reviewing your property and system, and are subject to a written agreement.",
      "Information on this website does not constitute a guarantee of system performance, savings or results.",
      `Questions about these terms can be sent to ${BUSINESS.email}.`,
      "[Business owner: review these terms with a legal professional before publishing.]",
    ],
  },
};

export default function LegalPage({ kind }) {
  const d = DOCS[kind];
  return (
    <main data-testid={`legal-page-${kind}`} className="bg-[#08090a] pt-[72px]">
      <Seo path={kind === "privacy" ? "/privacy-policy" : "/terms-of-service"} title={`${d.title} | Solar Energy Doc LLC`} description={`${d.title} for Solar Energy Doc LLC.`} />
      <div className="mx-auto max-w-3xl px-5 py-24 sm:px-8">
        <p className="eyebrow">Legal</p>
        <h1 className="mt-5 text-4xl sm:text-5xl font-semibold uppercase text-white">{d.title}</h1>
        <div className="mt-10 space-y-5 text-base leading-relaxed text-zinc-300">
          {d.body.map((p) => <p key={p}>{p}</p>)}
        </div>
        <Link to="/" className="btn btn-ghost mt-12" data-testid="legal-back-home">Back to Home</Link>
      </div>
    </main>
  );
}
